import { Card, CardContent } from "@/components/ui/card";

function Field({ label, children, testid }) {
  return (
    <div className="space-y-0.5">
      <div className="text-[10px] uppercase tracking-wider text-slate-500 font-medium">{label}</div>
      <div className="text-sm text-slate-900" data-testid={testid}>{children ?? "—"}</div>
    </div>
  );
}

/** "Resumo" tab — 4 high-level metrics about the patient. */
export default function ResumoTab({ patient, cases }) {
  return (
    <Card className="border-slate-200 shadow-sm">
      <CardContent className="p-6 grid grid-cols-2 md:grid-cols-4 gap-5">
        <Field label="Total de cirurgias">{cases.length}</Field>
        <Field label="Status">{patient.status}</Field>
        <Field label="CNS / SUS">{patient.cns}</Field>
        <Field label="CPF">{patient.cpf}</Field>
      </CardContent>
    </Card>
  );
}
